import { Button, Input, Modal } from "antd";

const QAModel = ({
  open,
  mode,
  handleCancel,
  formData,
  handleInputChange,
  handleSubmit,
  handleStatusChange,
}) => {
  const isEdit = mode === "edit";
  return (
    <>
      <Modal
        title={
          isEdit ? (
            <div className="container-fluid d-flex flex-column align-items-center text-center">
              <div className="d-flex justify-content-start flex-column w-100 mb-2">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50px",
                    background: "#052659",
                    color: "#FFFFFF",
                  }}
                >
                  <i className="bi bi-people icon"></i>
                </div>
                <div className="d-flex justify-content-start mt-3">
                  <span className="fs-5 fw-semibold">Edit QA</span>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column align-items-center text-center">
              <div className="d-flex justify-content-between w-100 mb-2">
                <span className="fs-5 fw-semibold">Adding a new QA</span>
              </div>
            </div>
          )
        }
        open={open}
        onCancel={handleCancel}
        width={750}
        footer={null}
      >
        <div className="container-fluid">
          <form className="row g-3 text-start" onSubmit={handleSubmit}>
            <div className="col-md-6">
              <label className="">
                First name<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                placeholder="Enter your first name"
                required
                style={{ fontSize: "14px" }}
              />
            </div>
            <div className="col-md-6">
              <label className="">
                Last name<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                placeholder="Enter your last name"
                required
              />
            </div>
            <div className="col-md-6">
              <label className="">
                Email address<span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="col-md-6">
              <label className="">
                User name<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                placeholder="Enter your user name"
                required
              />
            </div>
            <div className="col-md-6">
              <label className="">
                Phone<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    // only digits allowed
                    handleInputChange(e);
                  }
                }}
                placeholder="Enter your phone number"
                pattern="^[0-9]{10,13}$"
                title="Please enter a valid 10 to 13 digit phone number"
                required
                maxLength={13}
              />
            </div>
            <div className="col-md-6">
              <label className="">
                Enter password<span className="text-danger">*</span>
              </label>
              <Input.Password
                className="form-control"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="Enter password"
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                title="Password must be at least 8 characters long, include one uppercase letter, one lowercase letter, one number, and one special character."
                required
              />
            </div>

            {/* Status section only shown in Edit mode */}
            {isEdit && (
              <div className="d-flex flex-column mt-3">
                <label>Status</label>
                <div style={{ display: "flex", gap: "8px" }}>
                  <Button
                    key="active"
                    onClick={() => handleStatusChange("active")}
                    style={{
                      flex: 1,
                      background: formData.status === "active" ? "#00C853" : "transparent",
                      color: formData.status === "active" ? "#FFFFFF" : "#000000",
                      paddingTop: "20px",
                      paddingBottom: "20px",
                    }}
                  >
                    Active
                  </Button>
                  <Button
                    key="inactive"
                    onClick={() => handleStatusChange("inactive")}
                    style={{
                      flex: 1,
                      background: formData.status === "inactive" ? "#F44336" : "transparent",
                      color: formData.status === "inactive" ? "#FFFFFF" : "#000000",
                      paddingTop: "20px",
                      paddingBottom: "20px",
                    }}
                  >
                    Inactive
                  </Button>
                </div>
              </div>
            )}

            <div style={{ display: "flex", gap: "8px", marginTop: "50px" }}>
              <Button
                key="cancel"
                onClick={handleCancel}
                style={{
                  flex: 1,
                  background: "#FFEBEE",
                  color: "#F44336",
                  border: "none",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
              >
                Cancel
              </Button>
              <Button
                key="confirm"
                style={{
                  flex: 1,
                  background: "#052659",
                  color: "#FFFFFF",
                  border: "none",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
                htmlType="submit"
              >
                {isEdit ? "Save changes" : "Confirm"}
              </Button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default QAModel;
